import React from 'react';

export default class TextHighlightExplanationResponseStats extends React.Component {
  render() {
    // TODO: Build out these response stats.
    // Maybe build out a generic response stats thing.
    return null;
  }
}
